import { graphql } from '@/generated';

export const createDeviceMutation = graphql(`
  mutation createDevice(
    $input: DeviceInsertInput!
    $auditLogInput: AuditLogInsertInput!
  ) {
    insertDeviceOne(object: $input) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const updateDeviceMutation = graphql(`
  mutation updateDevice(
    $devicePkColumnInput: DevicePkColumnsInput!
    $setInput: DeviceSetInput!
    $auditLogInput: AuditLogInsertInput!
    $invalidateInput: InvalidateDeviceCacheInput!
  ) {
    updateDeviceByPk(pkColumns: $devicePkColumnInput, _set: $setInput) {
      id
    }
    invalidateDeviceCache(input: $invalidateInput) {
      items {
        deviceId
      }
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const refreshDeviceCacheMutation = graphql(`
  mutation refreshDeviceCache($invalidateInput: InvalidateDeviceCacheInput!) {
    invalidateDeviceCache(input: $invalidateInput) {
      items {
        deviceId
      }
    }
  }
`);

export const createUserDeviceLinkMutation = graphql(`
  mutation createUserDeviceLink(
    $input: UserDeviceLinkInsertInput!
    $auditLogInput: AuditLogInsertInput!
  ) {
    insertUserDeviceLinkOne(object: $input) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

// Links one user to many devices in a single request. The (UserId, DeviceId)
// uniqueness is a unique index rather than a constraint, so Hasura cannot
// upsert on it: callers must exclude existing pairs before inserting (see
// userDeviceLinksByUserAndDevicesQuery).
export const bulkAssignUserToDevicesMutation = graphql(`
  mutation bulkAssignUserToDevices(
    $inputs: [UserDeviceLinkInsertInput!]!
    $auditLogInput: AuditLogInsertInput!
  ) {
    insertUserDeviceLink(objects: $inputs) {
      affectedRows
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const createDeviceApiKeysMutation = graphql(`
  mutation createDeviceApiKeysMutation(
    $input: CreateDeviceApiKeysInput!
    $auditLogInput: AuditLogInsertInput!
  ) {
    createDeviceApiKeys(input: $input) {
      apiKeys {
        deviceId
        key
        reference
      }
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const deleteApiKeyMutation = graphql(`
  mutation deleteApiKey($id: bigint!, $auditLogInput: AuditLogInsertInput!) {
    deleteApiKeyByPk(id: $id) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const deleteUserDeviceLinkMutation = graphql(`
  mutation deleteUserDeviceLink(
    $id: uuid!
    $auditLogInput: AuditLogInsertInput!
  ) {
    deleteUserDeviceLinkByPk(id: $id) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const createUpdateRoiMutation = graphql(`
  mutation createUpdateRoiMutation(
    $zoneInsertInputs: [ZoneInsertInput!]!
    $roiInsertInputs: [RoiInsertInput!]!
    $deleteRoiInputs: [uuid!]!
    $updateRoiInputs: [RoiUpdates!]!
    $auditLogInput: AuditLogInsertInput!
  ) {
    insertZone(objects: $zoneInsertInputs) {
      affectedRows
    }
    insertRoi(objects: $roiInsertInputs) {
      affectedRows
    }
    deleteRoi(where: { id: { _in: $deleteRoiInputs } }) {
      affectedRows
    }
    updateRoiMany(updates: $updateRoiInputs) {
      affectedRows
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);

export const deleteDeviceMutation = graphql(`
  mutation deleteDevice(
    $apiKeyIds: [bigint!]!
    $deviceId: uuid!
    $auditLogInput: AuditLogInsertInput!
  ) {
    deleteApiKey(where: { id: { _in: $apiKeyIds } }) {
      affectedRows
    }
    deleteDeviceByPk(id: $deviceId) {
      id
    }
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);
